import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const getInitialLanguage = () => {
    const stored = localStorage.getItem('app_lang');
    if (stored) return stored;
    
    const browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase();
    return browserLang.startsWith('el') ? 'el' : 'en';
  };

  const [lang, setLang] = useState(getInitialLanguage());

  useEffect(() => {
    localStorage.setItem('app_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key, params = {}) => {
    let text = translations[lang][key] || translations['en'][key] || key;
    Object.keys(params).forEach(p => {
      text = text.replace(`{${p}}`, params[p]);
    });
    return text;
  };

  const toggleLanguage = () => {
    setLang(prev => (prev === 'en' ? 'el' : 'en'));
  };

  const changeLanguage = (newLang) => {
    if (newLang === 'en' || newLang === 'el') {
      setLang(newLang);
    }
  };

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLanguage, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);